/* unplugin-vue-components disabled */import { render } from "./select-sh-topics.vue?vue&type=template&id=131e7abb&scoped=true"
import script from "./select-sh-topics.vue?vue&type=script&lang=js"
export * from "./select-sh-topics.vue?vue&type=script&lang=js"

import "./select-sh-topics.vue?vue&type=style&index=0&id=131e7abb&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131e7abb"],['__file',"src/controls/select-sh-topics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "131e7abb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('131e7abb', __exports__)) {
    api.reload('131e7abb', __exports__)
  }
  
  module.hot.accept("./select-sh-topics.vue?vue&type=template&id=131e7abb&scoped=true", () => {
    api.rerender('131e7abb', render)
  })

}


export default __exports__